import React from "react";
import styled, { css } from "styled-components";
import { ListGroupItem } from "components/bootstrap";
const StyledListGroupItem = styled(ListGroupItem)(
  ({ theme }) => css`
    background-color: ${theme.colors.variant.lightest.default};
    font-size: ${theme.fonts.size.body};
    color: ${theme.utils.contrastingColor(theme.colors.variant.lightest.default)};
    padding: 0 15px;

    .form-group {
      margin: 0;
    }
  `
);
const HeaderWrapper = styled.div`
  padding: 10px 0;
  min-height: 40px;
`;
const ControlledTableListHeader = ({ children = "" }) => {
  const wrapStringChildren = (text) => /* @__PURE__ */ React.createElement(HeaderWrapper, null, text);
  const header = typeof children === "string" ? wrapStringChildren(children) : children;
  return /* @__PURE__ */ React.createElement(StyledListGroupItem, null, header);
};
export default ControlledTableListHeader;
